type CloseButtonProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  // Legacy prop, no longer affects rendering (kept for call-site compat).
  size?: number;
};

// The one drawer close button (design: 32px filled circle, quiet ×).
const CloseButton = ({ onClick }: CloseButtonProps) => {
  return (
    <button
      aria-label="Close"
      onClick={onClick}
      className="ml-auto w-8 h-8 shrink-0 rounded-full bg-surface-raised text-ink-secondary hover:text-ink-primary flex items-center justify-center cursor-pointer"
      type="button"
    >
      <svg
        stroke="currentColor"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="h-3.5 w-3.5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  );
};

export default CloseButton;
